import { render, staticRenderFns } from "./EnvSwitcher.vue?vue&type=template&id=77834466&scoped=true&"
import script from "./EnvSwitcher.vue?vue&type=script&lang=ts&"
export * from "./EnvSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./EnvSwitcher.vue?vue&type=style&index=0&id=77834466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77834466",
  null
  
)

export default component.exports